import UserType from 'constants/user';
import { useChatContext } from 'containers/chat/hooks/ChatContext';
import ComposeIcon from '../../assets/svg/composeIcon.svg';

export default function ChatCompose({ handleNewConversation }) {
    const { isInitiateNewConveration, user } = useChatContext();
    if (user?.userType === UserType.Customer) {
        return (
            <div
                style={{
                    width: 30,
                    height: 30,
                    borderRadius: 15,
                    border: '2px solid #D1D1D1',
                    cursor: 'pointer',
                    padding: '1px 0px 0px 5px',
                    opacity: isInitiateNewConveration ? 1 : 0.5,
                }}
                onClick={() => handleNewConversation()}
            >
                <img
                    src={ComposeIcon}
                    alt="Componse"
                    height={16}
                    width={16}
                    style={{
                        objectFit: 'cover',
                        marginBottom: '4px',
                    }}
                />
            </div>
        );
    }
    return null;
}
